export const ImportStatuses = ["PROCESSING", "FINISHED", "ERROR", "DISMISSED"] as const;

export type ImportStatus = (typeof ImportStatuses)[number];

export const ImportStatusLabels: Record<ImportStatus, string> = {
  PROCESSING: "Processing",
  FINISHED: "Finished",
  ERROR: "Error",
  DISMISSED: "Dismissed",
};
